import { getDoc, doc, updateDoc } from '@firebase/firestore';
import { db } from '../firebase/firebase-config';
import { Timestamp } from 'firebase/firestore';

export const getAndSetCurrentVersion = () => {
	getDoc(doc(db, 'updates', 'version'))
		.then((docSnap) => {
			const version = docSnap.data().version;
			localStorage.setItem('currentVersionPilu', version);
			console.log(`Running ${version} 🚀`);
		})
		.catch(() => {
			localStorage.setItem('currentVersionPilu', 'v0.0.0');
		});
};

export const incrementVersion = async (features) => {
	let currentVersion = localStorage.getItem('currentVersionPilu') || '0.0.0';
	const digits = currentVersion.split('.');
	const increment = parseInt(digits[2]) + 1;
	const newVersion = `${digits[0]}.${digits[1]}.${increment}`;

	await updateDoc(doc(db, 'updates', 'version'), {
		version: newVersion,
		features,
		updated_at: Timestamp.fromDate(new Date()),
	});
};
